export default class SettingKey {
  static get KkmServerPaymentEnabled () { return 'kkmServerPaymentEnabled' }
  static get KkmServerAcquiringDeviceNumber () { return 'kkmServerAcquiringDeviceNumber' }
  static get PaymentMethodsEnabled () { return 'paymentMethodsEnabled' }
  static get CheckQrCodeLink () { return 'check_qr_code_link' }
  static get PrinterCodePages () { return 'printerCodePages' }
  static get PreorderAutoPrepareEnabled () { return 'preorderAutoPrepareEnabled' }
  static get NewOrderSound () { return 'newOrderSound' }
  static get PreorderAutoPrepareSound () { return 'preorderAutoPrepareSound' }
}
